// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postApplyAudioSchemaToFleet } from '../../services/AudioSchemaService';
import { AudioSchemaPerFleet, ApplyAudioSchemaToFleetRequest } from '../../types/AudioSchemas';

type Result = UseMutationResult<AudioSchemaPerFleet, Error, ApplyAudioSchemaToFleetRequest>;

function usePostApplyAudioSchemaToFleet(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(postApplyAudioSchemaToFleet, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['audio-schemas'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePostApplyAudioSchemaToFleet;
